/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Hammad Kamran",
  title: "Hi all, I'm Hammad",
  subTitle: emoji(
"Full Stack Developer 🚀 focused on building scalable web and mobile apps with great UI/UX using React.js, Node.js, React Native, Swift UI, Next.js, and Firebase."
  ),
  resumeLink:
    "https://drive.google.com/file/d/1gUsuxaLHX77vKW5dBfMC5orslfQvQyqQ/view?usp=sharing", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/hammadkamran29",
  linkedin: "https://www.linkedin.com/in/hammad-kamran-604520248/",
  gmail: "hamadkamran94@gmail.com",
  // gitlab: "https://gitlab.com/saadpasta",
  facebook: "https://www.facebook.com/hamad.kamran.3",
  upwork: "https://www.upwork.com/freelancers/~0193bb077579fa8228?p=1833198284091416576",
  // medium: "https://medium.com/@saadpasta",
  // stackoverflow: "https://stackoverflow.com/users/10422806/saad-pasta",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "CRAZY FULL STACK DEVELOPER WHO WANTS TO EXPLORE EVERY TECH STACK",
  skills: [
    emoji(
      "⚡ Develop highly interactive Front end / User Interfaces for your web and mobile applications"
    ),
    emoji("⚡ Progressive Web Applications ( PWA ) in normal and SPA Stacks"),
    emoji(
      "⚡ Integration of third party services such as Firebase/ AWS / Digital Ocean"
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "sass",
      fontAwesomeClassname: "fab fa-sass"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "swift",
      fontAwesomeClassname: "fab fa-swift"
    },
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "aws",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "firebase",
      fontAwesomeClassname: "fas fa-fire"
    },
    {
      skillName: "python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "docker",
      fontAwesomeClassname: "fab fa-docker"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Information Technology  University",
      logo: require("./assets/logos/itu.jpeg"),
      subHeader: "Bachelors of Science in Computer Engineering",
      duration: "Apr 2020 - May 2024",
      desc: "Instructed students in React Native cross-platform development and Java-based Android programming, covering UI design, API integration, and performance optimization." ,
      descBullets: [
        "Taught React Native, Node.js, and Java for mobile development",
        "Guided 50+ students in projects, debugging, and app deployment"
    ]
    },
    {
      "schoolName": "Superior College",
      "logo": require("./assets/logos/superior.jpeg"),
      "subHeader": "High School Diploma, Pre-Engineering",
      "duration": "2018 - 2020",
      "desc": "Specialized in mathematics and computer science fundamentals.",
      "descBullets": [
        "Graduated with honors 87.5%",
        "Led school's Computer Club, organized hackathons"
      ]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true,
  experience: [
    {
      Stack: "React Native / Mobile Development",
      progressPercentage: "95%"
    },
    {
      Stack: "Firebase / Backend-as-a-Service",
      progressPercentage: "90%"
    },
    {
      Stack: "Frontend (React, UI/UX)",
      progressPercentage: "85%"
    },
    {
      Stack: "Next.js",
      progressPercentage: "80%"
    },
    {
      Stack: "Backend (Node.js / FastAPI)",
      progressPercentage: "75%"
    },
    {
      Stack: "SwiftUI",
      progressPercentage: "70%"
    },
    {
      Stack: "Version Control (Git & GitHub)",
      progressPercentage: "85%"
    },
    {
      Stack: "API Integration / Third-party Services",
      progressPercentage: "80%"
    },
    {
      Stack: "App Store / Play Store Deployment",
      progressPercentage: "85%"
    },
  ],
  displayCodersrank: false
};
// Work experience section

const workExperiences = {
  display: true,
  experience: [
    {
      role: "Software Engineer",
      company: "Granjur Technologies",
      companylogo: require("./assets/logos/granjur.jpeg"),
      date: "June 2023 – Present",
      desc: "Progressed from Intern to Software Engineer at Granjur Technologies, contributing to full-stack and cross-platform mobile app development with a focus on performance, scalability, and user experience.",
      descBullets: [
        "Improved app performance with optimized rendering and reduced API response time by 35%",
        "Led UI/UX redesigns that boosted user retention by 30%",
        "Optimized MySQL queries and designed 4 normalized databases, improving DB performance by 50%",
        "Established coding standards and introduced automated testing, reducing bugs by 40% and improving team efficiency by 25%"
      ]
    },
    {
      role: "Mobile App Developer",
      company: "Gathergram (Canada)",
      companylogo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRQ1i7HFcMWIdO8F2-4ys4PGEW3e_rXGGaBDg&s", 
      date: "December 2024 – Present",
      desc: "Working remotely as a part-time React Native Mobile App Developer, contributing to the development of a social platform for event content sharing & user engagement.",
      descBullets: [
        "Developed core mobile features using React Native aligned with modern UX standards",
        "Collaborated with a remote team to design scalable architecture and reusable components",
        "Integrated third-party libraries and APIs to enhance user experience and functionality",
        "Focused on performance optimization and responsive design for both iOS and Android"
      ]
    },
    // {
    //   role: "Mobile App Developer",
    //   company: "Badface (Shopify Store)",
    //   companylogo: "https://badface.store/cdn/shop/files/ZBADFACELOGO2.png?v=1725538734&width=600",
    //   date: "February 2025 – May 2025",
    //   desc: "Working with Badface, a Shopify-based fashion brand, to build and maintain a mobile app that enhances customer engagement and shopping experience.",
    //   descBullets: [
    //     "Developed a custom mobile shopping experience using React Native and Shopify Storefront API",
    //     "Integrated seamless product browsing, cart, and checkout flows with Shopify backend",
    //     "Implemented push notifications and real-time updates to improve user engagement",
    //     "Optimized app performance for smooth browsing across Android and iOS platforms"
    //   ]
    // }
    
    
    // {
    //   role: "Software Engineer",
    //   company: "Granjur Technologies",
    //   companylogo: "https://media.licdn.com/dms/image/v2/C4D0BAQEXwoDViQqw7Q/company-logo_200_200/company-logo_200_200/0/1664079193483?e=1752105600&v=beta&t=U04EHslt4jGX0QRJLV7JvNWyiDZfnp3kMNcIUYV17m4",
    //   date: "July 2024 – Present",
    //   desc: "Developing cross-platform mobile applications with React Native, focusing on performance optimization and user experience.",
    //   descBullets: [
    //     "Built 5+ production apps using React Native with 40% faster rendering through code optimization",
    //     "Implemented RESTful APIs with Node.js, reducing API response time by 35%",
    //     "Established coding standards that improved team productivity by 25%"
    //   ]
    // },
    // {
    //   role: "Associate Software Engineer",
    //   company: "Granjur Technologies",
    //   companylogo: "https://media.licdn.com/dms/image/v2/C4D0BAQEXwoDViQqw7Q/company-logo_200_200/company-logo_200_200/0/1664079193483?e=1752105600&v=beta&t=U04EHslt4jGX0QRJLV7JvNWyiDZfnp3kMNcIUYV17m4",
    //   date: "August 2023 – July 2024",
    //   desc: "Full-stack development of hybrid mobile applications using React Native with PHP-Laravel backend systems.",
    //   descBullets: [
    //     "Developed 3 cross-platform apps serving 10,000+ users",
    //     "Optimized MySQL databases, improving query performance by 50%",
    //     "Led UI/UX redesign that increased user retention by 30%"
    //   ]
    // },
    // {
    //   role: "Software Engineer Intern",
    //   company: "Granjur Technologies",
    //   companylogo: "https://media.licdn.com/dms/image/v2/C4D0BAQEXwoDViQqw7Q/company-logo_200_200/company-logo_200_200/0/1664079193483?e=1752105600&v=beta&t=U04EHslt4jGX0QRJLV7JvNWyiDZfnp3kMNcIUYV17m4",
    //   date: "June 2023 – August 2023",
    //   desc: "Gained hands-on experience in backend development and database optimization.",
    //   descBullets: [
    //     "Designed and normalized 4 relational databases using SQL",
    //     "Developed microservices with Node.js, reducing server costs by 20%",
    //     "Automated testing with Jest, decreasing bug reports by 40%"
    //   ]
    // }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: false // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    {
      image: require("./assets/images/FableMoi.png"),
      projectName: "FableMoi",
      projectDesc: "FableMoi is a Swift UI app where children create stories through choices that shape AI-generated adventures. With illustrated scenes, soft music, and a kid-friendly UI, it makes reading fun and interactive. Powered by Supabase and a C# backend, FableMoi offers smooth, dynamic storytelling with endless possibilities.",
      footerLink: [
        {
          name:"App Store Link",
          url:"https://apps.apple.com/tr/app/fablemoi/id6475584713"
        }
      ]
    },
    {
      image: require("./assets/images/fittour.png"),
      projectName: "Fit-Tour",
      projectDesc: "Fittour is an AI-powered React Native and Firebase app that generates personalized workout plans for travelers based on their location and available resources, featuring local fitness activities, instructional videos, and detailed exercise guidance.",
      footerLink: [
        {
          name:"Screen Recording",
          url:"https://drive.google.com/file/d/1iI0Cbz14h3__EBZB8j4pxijcqxtmWxmj/view?usp=sharing"
        }
      ]
    },
    {
      image: require("./assets/images/RacketRank.png"),
      projectName: "Racket Rank",
      projectDesc: "Racket Rank is a competitive, gamified React Native and Supabase app that connects nearby players for real-time match-making, live scoring, and in-app chat. Players can schedule matches, earn badges, track rankings, and receive push notifications—all designed to enhance local racket sports gameplay and community engagement.",
      footerLink: [
        {
          name:"Screen Recording",
          url:"https://drive.google.com/file/d/1iPwTcihSytiU_rHkFJF_S4FCAZAB3uhw/view?usp=sharing"
        }
      ]
    },
    {
      image: "https://res.cloudinary.com/djxpeip2r/image/upload/v1746973045/Screenshot_2025-05-11_at_7.17.16_PM_d8wd3u.png",
      projectName: "Antisocial",
      projectDesc: "Antisocial is a social media app built with React Native & firebase, featuring dynamic feed for posts, premium and free content posting, and post purchasing via In-App Purchases and withdrawals via Stripe.",
      footerLink: [
        {
          name:"Screen Recording",
          url:"https://drive.google.com/file/d/1MS6x-0jGeU86Ln0TWcYyOEMlahRy64sN/view?usp=sharing"
        },
        {
          name: "Download APK",
          url: "https://drive.google.com/file/d/1-l1xXF1nQLeunic5CWNE6KpmJRFBJ9Go/view?usp=sharing"
        },
        {
          name: "App Store Link",
          url: "https://apps.apple.com/fj/app/antisocial-app/id6745905591"
        }
      ]
    },
    {
      image: "https://res.cloudinary.com/djxpeip2r/image/upload/v1746970192/Badface_dnur1b.png",
      projectName: "Bad Face",
      projectDesc: "Bad Face is a Shopify-based mobile app built with React Native, featuring live product listings, seamless checkout, and image personalization for a customized shopping experience.",
      footerLink: [
        {
          name:"Screen Recording",
          url:"https://drive.google.com/file/d/1BPUPbbsjoT14asrgxjtxM4BbvDpMMn8T/view?usp=sharing"
        },
        {
          name: "Download APK",
          url: "https://drive.google.com/file/d/1_SXFsFKvvRiyeyNrjfmJYADYNadQ0VIc/view?usp=sharing"
        }
      ]
    },
    {
      image: "https://res.cloudinary.com/djxpeip2r/image/upload/v1746971812/Gathergram_qxiy0g.png",
      projectName: "Gthergram",
      projectDesc: "Gathergram is a cross-platform social and event app built with React Native, featuring event management, a feed for posts, and Stripe gifting—all from a single codebase.",
      footerLink: [
        {
          name:"Screen Recording",
          url:"https://drive.google.com/file/d/1Fow3-2xb7P6CXZAXdVNcNaRxOxuRnspJ/view?usp=sharing"
        },
        {
          name: "Download APK",
          url: "https://drive.google.com/file/d/12FIATux6ga94rE__fm2CjmeymL_rvgOC/view?usp=sharing"
        },
       
        //  you can add extra buttons here.
      ]
    },
    {
      image: "https://res.cloudinary.com/djxpeip2r/image/upload/v1746973229/Screenshot_2025-05-11_at_7.20.21_PM_xdyozu.png",
      projectName: "Meter Monitor",
      projectDesc: "Meter Monitor is a utility app built with React Native and Firebase that helps users track electricity, gas, water, or car meter readings, with consumption stats, cost predictions, and push notifications",
      footerLink: [
        {
          name:"Screen Recording",
          url:"https://www.upwork.com/freelancers/~0193bb077579fa8228?p=1833198284091416576"
        }
      ]
    },
    {
      image: "https://res.cloudinary.com/djxpeip2r/image/upload/v1746969161/Screenshot_2025-05-11_at_6.12.33_PM_r6xcg8.png",
      projectName: "Movie Maze",
      projectDesc: "Movie Maze is a android movie app built with JAVA, featuring live streaming of movies and TV shows, and a feed for posts.",
      footerLink: [
        {
          name: "Screen Recording",
          url: "https://drive.google.com/file/d/13pPq47uNHqvvlrCSpqZYXhAaQeSYYyvX/view?usp=sharing"
        }
      ]
    },
    {
      image: require("./assets/images/chat_pk.png"),
      projectName: "Chat PK",
      projectDesc: "A chatting app I am currently working on as my personal project. Built with React Native and Firebase, featuring VoIP push notifications, audio/video calling, and real-time messaging.",
      footerLink: [
        {
          name: "Screen Recording",
          url: "https://drive.google.com/file/d/1Jw9w2Bj8NUjSYVAMs4SBumZ8BJP2pCgY/view?usp=sharing"
        }
      ]
    },
    {
      image: require("./assets/images/Squago.png"),
      projectName: "Squago",
      projectDesc: "SwiftUI iOS travel app with trip creation—users can join via the Trip feed or invites. Within a trip, users join or create activities and invite friends. Includes push notifications, quick chat messaging, and a cache system.",
      footerLink: [
        {
          name: "Screen Recording",
          url: "https://drive.google.com/file/d/1UbJV-xGdn7fhFyzQ_dVVI8UVJWnxAyxx/view?usp=sharing"
        }
      ]
    },

    {
      image: require("./assets/images/timelessReputation.png"),
      projectName: "Timeless Reputation",
      projectDesc: "Built a production B2B reputation management platform end-to-end — Next.js frontend, Express/Prisma backend, HubSpot CRM + Conversations, meeting booking, UTM attribution, and live deployment on Netlify + Render.",
      footerLink: [
        {
          name: "View Live Site",
          url: "https://www.timelessreputation.com"
        },
      ]
    },
    // {
    //   image: "https://hamadkamran.netlify.app/static/media/HadithApp.037e971f241bfe874176.png",
    //   projectName: "Hadith App",
    //   projectDesc: "Hadith App is my first ever app that I built with React Native. It is a simple app that allows users to read and search through the hadiths.",
    //   footerLink: [
    //     // {
    //     //   name: "Download APK",
    //     //   url: "http://nextu.se/"
    //     // }
    //   ]
    // },
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Google Code-In Finalist",
      subtitle:
        "First Pakistani to be selected as Google Code-in Finalist from 4000 students from 77 different countries.",
      image: require("./assets/images/codeInLogo.webp"),
      imageAlt: "Google Code-In Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dYkVvNjdNWjNybWJrbndFSHpNY2NFV1p4YmU0/view?usp=sharing"
        },
        {
          name: "Award Letter",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dekxBTW5hQkg2WXUyR3QzQmR0VERiLXlGRVdF/view?usp=sharing"
        },
        {
          name: "Google Code-in Blog",
          url: "https://opensource.googleblog.com/2019/01/google-code-in-2018-winners.html"
        }
      ]
    },
    {
      title: "Google Assistant Action",
      subtitle:
        "Developed a Google Assistant Action JavaScript Guru that is available on 2 Billion devices world wide.",
      image: require("./assets/images/googleAssistantLogo.webp"),
      imageAlt: "Google Assistant Action Logo",
      footerLink: [
        {
          name: "View Google Assistant Action",
          url: "https://assistant.google.com/services/a/uid/000000100ee688ee?hl=en"
        }
      ]
    },

    {
      title: "PWA Web App Developer",
      subtitle: "Completed Certifcation from SMIT for PWA Web App Development",
      image: require("./assets/images/pwaLogo.webp"),
      imageAlt: "PWA Logo",
      footerLink: [
        {name: "Certification", url: ""},
        {
          name: "Final Project",
          url: "https://pakistan-olx-1.firebaseapp.com/"
        }
      ]
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",

  // Please Provide with Your Podcast embeded Link
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+92-3090000323",
  email_address: "hamadkamran94@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = false; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
